import IndexView from "../views/home/index.vue";

export default [
	{
		path: "/",
		redirect: "/dashboard",
	},
	{
		path: "/",
		name: "Index",
		component: IndexView,
		children: [
			{
				path: "/dashboard",
				name: "Dashboard",
				meta: {
					title: "Dashboard",
					active: 2,
					permissions: "biInfo",
				},
				component: () => import("../views/dashboard/index.vue"),
			},
			{
				path: "/map",
				name: "Map",
				meta: {
					title: "Map",
				},
				component: () => import("../views/map/index.vue"),
			},
			{
				path: "/revenue",
				name: "Revenue",
				meta: {
					title: "EV Charging Revenue",
					active: 2,
					permissions: "biInfo",
				},
				component: () => import("../views/revenue/index.vue"),
			},
			{
				path: "/pricing",
				name: "Pricing",
				meta: {
					title: "Pricing",
					active: 87,
					permissions: "siteInfo",
				},
				component: () => import("../views/pricing/index.vue"),
			},
			{
				path: "/pricing/:id",
				name: "PriceSettings",
				meta: {
					title: "Price Settings",
				},
				component: () => import("../views/priceSettings/index.vue"),
			},
			{
				path: "/alerts",
				name: "Alerts",
				meta: {
					title: "Alerts",
					active: 87,
					permissions: "siteInfo",
				},
				component: () => import("../views/alerts/index.vue"),
			},
			{
				path: "/notification",
				name: "NotificationCenter",
				meta: {
					title: "Notification Center",
					permissions: "deviceAlertInfo",
				},
				component: () => import("../views/notificationCenter/index.vue"),
			},
			{
				path: "/stations",
				name: "Stations",
				meta: {
					title: "Stations",
				},
				component: () => import("../views/stations/index.vue"),
			},
			{
				path: "/screenConfiguration",
				name: "ScreenConfiguration",
				meta: {
					title: "Screen Configuration",
					permissions: "deviceInfo",
				},
				component: () => import("../views/screenConfiguration/index.vue"),
			},
			{
				path: "/screenConfigurationDetails/:type",
				name: "ScreenConfigurationDetails",
				meta: {
					title: "Screen Configuration",
					permissions: "deviceInfo",
				},
				component: () => import("../views/screenConfigurationDetails/index.vue"),
			},
			{
				path: "/stations/:id",
				name: "StationConfiguration",
				meta: {
					title: "Station Configuration",
				},
				component: () => import("../views/stationConfiguration/index.vue"),
			},
			{
				path: "/chargers",
				name: "Chargers",
				meta: {
					title: "Devices",
				},
				component: () => import("../views/chargers/index.vue"),
			},
			{
				path: "/charger/:id",
				name: "ChargerDetails",
				meta: {
					title: "Charger Details",
				},
				component: () => import("../views/chargerDetails/index.vue"),
			},
			{
				path: "/charger/C8S/:id",
				name: "C8SChargerDetails",
				meta: {
					title: "Device Overview", // C8S设备组详情页
				},
				component: () => import("../views/chargerDetailsC8S/index.vue"),
			},
			{
				path: "/charger/PCS/:id",
				name: "C8SLiteChargerDetails",
				meta: {
					title: "PCS Unit Information", // C8S Lite 设备详情页
				},
				component: () => import("../views/chargerDetailsC8SLite/index.vue"),
			},
			{
				path: "/energy",
				name: "EnergyMicrogrid",
				meta: {
					title: "Energy Microgrid",
				},
				component: () => import("../views/energyMicrogrid/index.vue"),
			},
			{
				path: "/energy/:id",
				name: "EnergyMicrogridConfiguration",
				meta: {
					title: "Energy Microgrid Configuration ",
				},
				component: () => import("../views/energyMicrogridConfiguration/index.vue"),
			},
			{
				path: "/bill",
				name: "bill",
				meta: {
					title: "Charging Session",
				},
				component: () => import("../views/bill/index.vue"),
			},
			{
				path: "/billDetail/:id",
				name: "billDetail",
				meta: {
					title: "Session Details",
				},
				component: () => import("../views/billDetail/index.vue"),
			},
			{
				path: "/contrastCurve/:id",
				name: "contrastCurve",
				meta: {
					title: "Charge Curves",
				},
				component: () => import("../views/contrastCurve/index.vue"),
			},
			{
				path: "/energyTransfer",
				name: "EnergyTransfer",
				meta: {
					title: "Energy Transfer",
				},
				component: () => import("../views/energyTransfer/index.vue"),
			},
			{
				path: "/energyTransferDetail/:id",
				name: "EnergyTransferDetails",
				meta: {
					title: "Energy Transfer Details",
				},
				component: () => import("../views/energyTransferDetails/index.vue"),
			},
			{
				path: "/energyTransferView/:id",
				name: "EnergyTransferView",
				meta: {
					title: "Energy Transfer Details",
				},
				component: () => import("../views/energyTransferView/index.vue"),
			},
			{
				path: "/fleets",
				name: "Fleets",
				meta: {
					title: "Fleets",
				},
				component: () => import("../views/fleets/index.vue"),
			},
			{
				path: "/fleetDetails/:id",
				name: "FleetDetails",
				meta: {
					title: "FleetDetails",
				},
				component: () => import("../views/fleetDetails/index.vue"),
			},
			{
				path: "/fleetsChargeRecord/:id",
				name: "FleetsChargeRecord",
				meta: {
					title: "Top-up record",
				},
				component: () => import("../views/fleetsChargeRecord/index.vue"),
			},
			{
				path: "/chargingCards",
				name: "ChargingCards",
				meta: {
					title: "Charging Cards",
				},
				component: () => import("../views/chargingCards/index.vue"),
			},
			{
				path: "/chargingCards/:id",
				name: "ChargingCardDetails",
				meta: {
					title: "Charging Card Details",
				},
				component: () => import("../views/chargingCardDetails/index.vue"),
			},
			{
				path: "/account",
				name: "Account",
				meta: {
					title: "Account",
				},
				component: () => import("../views/account/index.vue"),
			},
			{
				path: "/stationManagement/:id",
				name: "AccountStationManagement",
				meta: {
					title: "Station management",
				},
				component: () => import("../views/accountStationManagement/index.vue"),
			},
			{
				path: "/powerAllocate/:id",
				name: "powerAllocate",
				meta: {
					title: "powerAllocate",
				},
				component: () => import("../views/powerAllocate/index.vue"),
			},
			{
				path: "/cpoInfo",
				name: "CPOInfo",
				meta: {
					title: "CPO Info",
				},
				component: () => import("../views/cpoInfo/index.vue"),
			},
			{
				path: "/customMode",
				name: "CustomMode",
				meta: {
					title: "Custom Mode",
				},
				component: () => import("../views/customMode/index.vue"),
			},
			{
				path: "/workingModeList",
				name: "WorkingModeList",
				meta: {
					title: "Working Mode SCH List",
				},
				component: () => import("../views/workingModeList/index.vue"),
			},
		],
	},
	{
		path: "/billReceipt",
		name: "BillReceipt",
		meta: {
			title: "Bill Receipt",
		},
		component: () => import("../views/billReceipt/index.vue"),
	},
	{
		path: "/login",
		name: "Login",
		meta: {
			title: "Login",
		},
		component: () => import("../views/login/index.vue"),
	},
	{
		path: "/resetPassword",
		name: "ResetPassword",
		meta: {
			title: "Reset Password",
		},
		component: () => import("../views/resetPassword/index.vue"),
	},
	{
		path: "/registerInternational.html",
		name: "Register",
		meta: {
			title: "Register",
		},
		component: () => import("../views/register/index.vue"),
	},
];
